import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { QuotaMovementsBatchService } from 'app/_services/quota-movements-batch.service';
import { QuotaMovementsBatch } from 'app/_models/quota-movements-batch';
import { List } from 'app/shared/list';
import { NotificationsService } from 'app/_services/notifications.service';

@Component({
  selector: 'app-quota-movements-batch-list',
  templateUrl: './quota-movements-batch-list.component.html',
  styleUrls: ['./quota-movements-batch-list.component.css'],
  providers: [QuotaMovementsBatchService],
})
export class QuotaMovementsBatchListComponent extends List implements OnInit {
  constructor(
    private quotaMovementsBatchService: QuotaMovementsBatchService,
    private notificationsService: NotificationsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(quotaMovementsBatchService, new QuotaMovementsBatch(), router, route);
  }

  public ngOnInit() {
    this.initList('quotas-batchs', null);
  }

  public delete(line: QuotaMovementsBatch) {
    this.quotaMovementsBatchService.delete(line.id).subscribe(
      (empty) => {
        this.list(this.currentPage);
        this.notificationsService.notify('success', 'Eliminar comunicación', 'La comunicación se ha elimiado correctamente');
      },
      (error) => {
        this.notificationsService.notify('error', 'Eliminar comunicación', error.body[0]);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-batchs/quota-movements-batch-list/quota-movements-batch-list.component.ts